module.exports = __webpack_public_path__ + "static/media/marketing.85587dce.jpg";